module.exports = __webpack_public_path__ + "static/media/Promo2x1.899315cc.png";